export function formatModelPrice(input: number, output: number): string {
  return `$${input}/$${output} per 1M tokens`;
}

export function formatCost(cost: number): string {
  if (cost < 0.01) {
    return `$${cost.toFixed(4)}`;
  } else {
    return `$${cost.toFixed(2)}`;
  }
}
